function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Object, String, currentTab, error, isLoading, orgs, overSeatCount, selectedOrg, serviceAccount, userFile, userRows) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['invite-users-row'] = function(row, idx) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'invite-users-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          const isServiceAccount = $helpers.isServiceAccount();
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'invite-users-column': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((isServiceAccount) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'invite-users-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Name");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'invite-users-input-container': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-input", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    'error-message': row.nameErrorMsg,
                    'validation-status': $helpers.serviceAccountNameValidationStatus(row),
                  }),
                  "props": {
                    value: row.name,
                  },
                  "on": {
                    input: ev => $helpers.updateServiceAccountName(ev, row),
                  },
                  "class": {
                    'invite-users-service-account-name': true
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((!idx) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'invite-users-title': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Email Address");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'invite-users-input-container': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("input", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    type: `text`,
                    /* autocomplete=off does not work as of Chrome 34 */
                    autocomplete: `invite-users-autocomplete-off`,
                  }),
                  "props": {
                    value: row.email,
                  },
                  "on": {
                    input: ev => $helpers.updateUserEmail(ev, row),
                    focus: $helpers.clearErrors,
                    blur: ev => $helpers.updateEmailError(ev, row),
                  },
                  "class": {
                    'invite-users-input': true,
                    'invite-users-email-input': true
                  },
                }));
                __jade_nodes = __jade_nodes.concat(((row.emailError || row.emailInfo) && row === userRows.find(userRow => userRow.email === row.email)) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      'always-show': true,
                      'type': row.emailInfo ? `default` : `error`,
                      'placement': `left`,
                    }),
                  }, (function() {
                    var __jade_nodes = [];
                    const descriptor = row.email && row.email.length ? `a valid` : `an`;;
                    __jade_nodes = __jade_nodes.concat(row.emailErrorMsg || `Please enter ${descriptor} email address`);;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'invite-users-column': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((!idx) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'invite-users-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Organization Role");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'invite-users-input-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-select", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  'selected-option': row.orgRole ? $helpers.capitalize(row.orgRole) : `Select role`,
                  'menu-height': 350,
                  /* menu with 4 roles is just over 200px, looks weird */
                  'size': `large`,
                }),
                "props": {
                  sections: $helpers.getOrgRoleSections(),
                },
                "on": {
                  change: ev => $helpers.selectOrgRole(ev, row),
                  focus: $helpers.clearErrors,
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat((row.orgRoleError && row === userRows.find(row => row.orgRoleError)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  'always-show': true,
                  'type': `error`,
                  'placement': `top`,
                }),
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Please select a role");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat((currentTab === $helpers.TABS.PROJECT) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "style": {
                width: `250px`
              },
              "class": {
                'invite-users-column': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((!idx) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'invite-users-title': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Projects");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              const numProjects = row.projectIds.length;;
              const projectPlural = $helpers.pluralize(`project`, numProjects);;
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'invite-users-input-container': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-select", {
                  "style": {
                    height: `40px`,
                    width: `250px`
                  },
                  "attrs": __vjadeStringifyAttrsIfObj({
                    'selected-option': numProjects ? `${numProjects} ${projectPlural}` : `Select projects`,
                    'multiple': true,
                    'show-select-all': true,
                    'menu-width': `250`,
                  }),
                  "props": {
                    sections: $helpers.getProjectSections(row),
                  },
                  "on": {
                    change: ev => $helpers.toggleProjectSelected(ev, row),
                    selectAll: ev => $helpers.toggleAllProjectsSelected(ev, row),
                    focus: $helpers.clearErrors,
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat((row.projectError && row === userRows.find(row => row.projectError)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    'always-show': true,
                    'type': `error`,
                    'placement': `top`,
                  }),
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Please select at least one project");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'invite-users-column': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((!idx) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'invite-users-title': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Project Role");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'invite-users-input-container': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-select", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    'selected-option': row.projectRole ? $helpers.capitalize(row.projectRole) : `Select role`,
                    'menu-height': 300,
                    /* menu with 4 roles is just over 200px, looks weird */
                    'size': `large`,
                  }),
                  "props": {
                    sections: $helpers.getProjectRoleSections(),
                  },
                  "on": {
                    change: ev => $helpers.selectProjectRole(ev, row),
                    focus: $helpers.clearErrors,
                  },
                }));
                __jade_nodes = __jade_nodes.concat((row.projectRoleError && row === userRows.find(row => row.projectRoleError)) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      'always-show': true,
                      'type': `error`,
                      'placement': `right`,
                    }),
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("Please select a role");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((currentTab === $helpers.TABS.TEAM) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'invite-users-column': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((!idx) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'invite-users-title': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Teams");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              const numTeams = row.teamNames.length;;
              const teamPlural = $helpers.pluralize(`team`, numTeams);;
              __jade_nodes = __jade_nodes.concat(h("mp-select", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  'selected-option': numTeams ? `${numTeams} ${teamPlural}` : `Select teams`,
                  'multiple': true,
                  'show-select-all': true,
                  'size': `large`,
                }),
                "props": {
                  sections: $helpers.getTeamSections(row),
                },
                "on": {
                  change: ev => $helpers.toggleTeamSelected(ev, row),
                  selectAll: ev => $helpers.toggleAllTeamsSelected(ev, row),
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((userRows.length > 1) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "on": {
                click: () => $helpers.clickedDeleteButton(row)
              },
              "class": {
                'invite-users-remove-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: `x`
                }),
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat((row.projectIdsToDowngrade.length) ? ((function() {
          var __jade_nodes = [];
          const downgradedProjectsString = $helpers.getDowngradedProjectsString(row);
          const allDowngradedProjectsString = $helpers.getAllDowngradedProjectsString(row);
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'invite-users-row-error': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'invite-users-error-title': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("You do not have permission to assign the Project Role of Owner for all");
              __jade_nodes = __jade_nodes.concat(" the selected projects.");
              __jade_nodes = __jade_nodes.concat(" Admin will be assigned for " + (row.projectIdsToDowngrade.length) + " projects:");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat((row.seeAll) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'projects-list': true
                },
              }, [__vjadeSafeCode(allDowngradedProjectsString)]));;
              return __jade_nodes
            }).call(this)) : ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'project-list': true
                },
              }, [__vjadeSafeCode(downgradedProjectsString)]));
              __jade_nodes = __jade_nodes.concat((downgradedProjectsString.length < allDowngradedProjectsString.length) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "on": {
                    click: () => $helpers.seeAllDowngradedProjects(idx)
                  },
                  "class": {
                    'invite-users-see-all': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("See All");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'settings-screen-modal': true
        },
      }, (function() {
        var __jade_nodes = [];
        const isServiceAccount = $helpers.isServiceAccount();
        __jade_nodes = __jade_nodes.concat(h("mp-modal", {
          "attrs": __vjadeStringifyAttrsIfObj({
            open: $attr(`open`)
          }),
          "on": {
            change: $helpers.modalVisibilityChanged
          },
          "class": {
            'invite-users-modal': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((isServiceAccount) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-modal-header': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((isLoading) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-spinner", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    color: `white`
                  }),
                }));;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Create Service Account");;
                return __jade_nodes
              }).call(this)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat((error) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-banner", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  theme: "warn",
                  type: "embedded",
                  "header-text": "There was an error creating the service account.",
                  "body-text": error
                }),
                "class": {
                  'invite-users-error-banner': true
                },
              }));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat((!serviceAccount) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'invite-users-add-users': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((function() {
                  var $$obj = (userRows);
                  var $$eachNodes;
                  var $$iterated = false;
                  if (Array.isArray($$obj)) {
                    $$eachNodes = $$obj.reduce(function($$eachNodes, row, idx) {
                      $$iterated = true;
                      return $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(jade_mixins['invite-users-row'].call(this, row, idx));;
                        return __jade_nodes
                      }).call(this));
                    }, []);
                  } else {
                    $$eachNodes = [];
                    for (var $$objKey in $$obj) {
                      (function() {
                        var idx = $$objKey;
                        if ($$obj.hasOwnProperty(idx)) {
                          $$iterated = true;
                          var row = $$obj[idx];
                          $$eachNodes = $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(jade_mixins['invite-users-row'].call(this, row, idx));;
                            return __jade_nodes
                          }).call(this));
                        }
                      })();
                    }
                  }

                  return $$eachNodes;
                })());;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-modal-bottom-buttons': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    theme: `primary`,
                    disabled: isLoading || !$attr(`open`) || !selectedOrg || $helpers.hasInvalidName()
                  }),
                  "on": {
                    click: $helpers.clickedSave
                  },
                  "class": {
                    'mp-modal-button': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Create");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "on": {
                    click: $helpers.clickedCancel
                  },
                  "class": {
                    'mp-modal-button': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Cancel");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'copy-container': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'copy-token-warning': true,
                    'mp-font-weight-bold': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Make sure you save the service account's secret. You will never be able to access it again.");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'modal-content-container': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'modal-content-row': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-copy-to-clipboard", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        label: 'Username',
                        value: serviceAccount.username,
                      }),
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'modal-content-row': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-copy-to-clipboard", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        label: 'Secret',
                        value: serviceAccount.secret,
                      }),
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-modal-bottom-buttons': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "on": {
                    click: $helpers.handleClickedDone
                  },
                  "class": {
                    'mp-modal-button': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Done");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-modal-header': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((isLoading) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-spinner", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    color: `white`
                  }),
                }));;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Invite New Users");;
                return __jade_nodes
              }).call(this)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-modal-tab-section': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-toggle", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  selected: currentTab,
                  theme: `tab-bar`,
                }),
                "on": {
                  select: $helpers.selectTab,
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-toggle-option", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    value: $helpers.TABS.PROJECT
                  }),
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Invite to projects");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("mp-toggle-option", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    value: $helpers.TABS.TEAM
                  }),
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Invite to teams");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("mp-toggle-option", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    value: $helpers.TABS.BULK
                  }),
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Bulk invite");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat((orgs.length > 1) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'invite-users-select-org': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'invite-users-title': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("organization");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("mp-select", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    'selected-option': selectedOrg ? selectedOrg.name : `Select organization`,
                    'size': `large`,
                  }),
                  "props": {
                    sections: $helpers.getOrgSections(),
                  },
                  "on": {
                    change: $helpers.selectOrg,
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": Object.assign({}, {
                'invite-users-hidden': !selectedOrg
              }, {
                'invite-users-add-users': true
              }),
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((selectedOrg && $helpers.isOverSeatCount()) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'invite-users-warning-text-container': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      icon: `warning`
                    }),
                  }));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'invite-users-warning-text': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("You have run out of seats in your organization!");
                    __jade_nodes = __jade_nodes.concat(` `);
                    __jade_nodes = __jade_nodes.concat(($helpers.hasBillingPerms()) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Click");
                        __jade_nodes = __jade_nodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(" ");;
                          return __jade_nodes
                        }).call(this));
                        __jade_nodes = __jade_nodes.concat("");;
                        return __jade_nodes
                      }).call(this));
                      __jade_nodes = __jade_nodes.concat(h("a", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          href: `/pricing`
                        }),
                        "on": {
                          click: $helpers.trackUpsellClick
                        },
                        "props": {
                          id: 'pricing-link'
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("here");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(" to upgrade your plan.");;
                      return __jade_nodes
                    }).call(this)) : ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("Contact your organization's billing admin or owner to upgrade your plan.");;
                      return __jade_nodes
                    }).call(this)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat((currentTab === $helpers.TABS.PROJECT || currentTab === $helpers.TABS.TEAM) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((selectedOrg) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat((function() {
                    var $$obj = (userRows);
                    var $$eachNodes;
                    var $$iterated = false;
                    if (Array.isArray($$obj)) {
                      $$eachNodes = $$obj.reduce(function($$eachNodes, row, idx) {
                        $$iterated = true;
                        return $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(jade_mixins['invite-users-row'].call(this, row, idx));;
                          return __jade_nodes
                        }).call(this));
                      }, []);
                    } else {
                      $$eachNodes = [];
                      for (var $$objKey in $$obj) {
                        (function() {
                          var idx = $$objKey;
                          if ($$obj.hasOwnProperty(idx)) {
                            $$iterated = true;
                            var row = $$obj[idx];
                            $$eachNodes = $$eachNodes.concat((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(jade_mixins['invite-users-row'].call(this, row, idx));;
                              return __jade_nodes
                            }).call(this));
                          }
                        })();
                      }
                    }

                    return $$eachNodes;
                  })());;
                  return __jade_nodes
                }).call(this)) : undefined);
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'invite-users-add-another-user': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "on": {
                      click: $helpers.clickedAddMoreUser
                    },
                    "class": {
                      'invite-users-add-another-user-button': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        icon: `plus`
                      }),
                    }));
                    __jade_nodes = __jade_nodes.concat("Add another user");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'invite-users-add-another-user-alignment': true
                    },
                  }));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat((currentTab === $helpers.TABS.BULK) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'invite-users-bulk-add-users': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'invite-users-bulk-add-users-title': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("File name");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'invite-users-bulk-add-file-uploader': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-file-uploader", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        accept: `text/csv`,
                        label: `Select CSV File`,
                        'completed-filename': userFile && userFile.name ? userFile.name : ``,
                        'enable-delete': true,
                        'max-filename-chars': 120,
                      }),
                      "on": {
                        change: $helpers.fileStatusChanged,
                        delete: $helpers.removeSelectedFile
                      },
                    }));
                    __jade_nodes = __jade_nodes.concat((userFile && userFile.error) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          'always-show': true,
                          'type': `error`,
                          'placement': `right`,
                        }),
                      }, [__vjadeSafeCode(userFile.errorMsg || `Please select a CSV file`)]));;
                      return __jade_nodes
                    }).call(this)) : undefined);;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'invite-users-bulk-add-users-subtitle': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("Please follow the format of our");
                    __jade_nodes = __jade_nodes.concat(h("a", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        href: `https://cdn.mxpnl.com/static/organizations/bulk_add_template.csv`,
                        download: `bulk_adding_template.csv`,
                      }),
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("CSV template");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-modal-bottom-buttons': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  theme: `primary`,
                  disabled: isLoading || !$attr(`open`) || overSeatCount || !selectedOrg
                }),
                "on": {
                  click: $helpers.clickedSave
                },
                "class": {
                  'mp-modal-button': true
                },
              }, [__vjadeSafeCode(currentTab === $helpers.TABS.BULK ? `Upload` : `Invite`)]));
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "on": {
                  click: $helpers.clickedCancel
                },
                "class": {
                  'mp-modal-button': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Cancel");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "currentTab" in locals ? locals.currentTab : typeof currentTab !== "undefined" ? currentTab : undefined, "error" in locals ? locals.error : typeof error !== "undefined" ? error : undefined, "isLoading" in locals ? locals.isLoading : typeof isLoading !== "undefined" ? isLoading : undefined, "orgs" in locals ? locals.orgs : typeof orgs !== "undefined" ? orgs : undefined, "overSeatCount" in locals ? locals.overSeatCount : typeof overSeatCount !== "undefined" ? overSeatCount : undefined, "selectedOrg" in locals ? locals.selectedOrg : typeof selectedOrg !== "undefined" ? selectedOrg : undefined, "serviceAccount" in locals ? locals.serviceAccount : typeof serviceAccount !== "undefined" ? serviceAccount : undefined, "userFile" in locals ? locals.userFile : typeof userFile !== "undefined" ? userFile : undefined, "userRows" in locals ? locals.userRows : typeof userRows !== "undefined" ? userRows : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;